/**
 * Sur /share/<token>, l URL EST le secret : elle donne acces, sans authentification,
 * aux couches et modeles 3D partages. Sentry recoit l URL de la page, le nom de la
 * transaction et les fils d Ariane (navigation + fetch, dont les appels d API qui
 * portent eux aussi le token). Ce module masque le segment, partout.
 */

/**
 * Le segment qui suit /share/ est masque QUEL QU IL SOIT : se caler sur la forme
 * actuelle du token (base64url, 43 caracteres) rouvrirait la fuite en silence le jour
 * ou le back changerait sa generation. Le `/` avant `share` et celui qui suit bornent
 * un segment de chemin entier, donc /dashboard/shares ou ?utm=share restent intacts.
 */
const SHARE_SEGMENT = /\/share\/[^/?#&\s]+/g

const MASKED = '/share/[token]'

export const redactShareToken = value =>
  typeof value === 'string' ? value.replace(SHARE_SEGMENT, MASKED) : value

export const isPublicSharePath = pathname =>
  typeof pathname === 'string' && pathname.startsWith('/share/')

// Metadonnees internes du SDK (references vers la requete, la scope, l evenement
// d origine) : non envoyees telles quelles, et les parcourir n apporterait rien.
const SKIP = 'sdkProcessingMetadata'

// Les evenements sont deja normalises (normalizeDepth) quand beforeSend les recoit ;
// la borne evite juste qu une structure pathologique fasse deborder la pile ICI, ce qui
// couperait toute remontee d erreur.
const MAX_DEPTH = 12

const redactDeep = (node, seen, depth) => {
  if (depth > MAX_DEPTH || seen.has(node)) return
  seen.add(node)

  for (const key of Object.keys(node)) {
    if (key === SKIP) continue
    const value = node[key]
    if (typeof value === 'string') {
      const masked = redactShareToken(value)
      // Reaffecter seulement si ca change : hors partage, l evenement ressort a l identique.
      if (masked !== value) node[key] = masked
    } else if (value && typeof value === 'object') {
      redactDeep(value, seen, depth + 1)
    }
  }
}

/**
 * Hook `beforeSend` / `beforeSendTransaction`. Parcourt tout l evenement plutot que les
 * seuls champs connus : chaque integration ajoute ses propres URL (spans, contexte de
 * trace, en-tetes), et une liste nominative se perimerait sans bruit.
 * Masque, ne supprime jamais : les erreurs de production restent visibles.
 */
export const redactSentryEvent = event => {
  if (event && typeof event === 'object') redactDeep(event, new WeakSet(), 0)
  return event
}
